import React from 'react';
import { Gamepad2 } from 'lucide-react';

export default function PlatformPicker({ platforms, value, onChange }) {
  return (
    <div data-testid="platform-picker" className="max-w-md">
      <p className="text-xs uppercase tracking-[0.35em] text-white/40 font-mono mb-3">Choose your console</p>
      <div className="grid grid-cols-2 gap-3">
        {platforms.map((pl) => {
          const active = value === pl.id;
          return (
            <button
              key={pl.id}
              type="button"
              data-testid={`platform-option-${pl.id}`}
              aria-pressed={active}
              onClick={() => onChange(pl.id)}
              className={`flex items-center justify-center gap-2 py-3.5 rounded-xl border font-display font-bold tracking-wide transition-colors duration-200 ${
                active
                  ? 'bg-brand/15 border-brand text-white shadow-[0_0_24px_rgb(var(--brand-rgb)/0.35)]'
                  : 'bg-white/[0.03] border-white/10 text-white/60 hover:border-white/30 hover:text-white'
              }`}
            >
              <Gamepad2 className="h-4 w-4" /> {pl.label}
            </button>
          );
        })}
      </div>
      {!value && <p className="mt-2 text-xs text-white/40">You&apos;ll receive the file for the console you pick.</p>}
    </div>
  );
}
